import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@lsq/nextgen/v2/button';

import './index.css';
import { useTranslation } from 'react-i18next';

const varirntMap = {
  filled: 'primary',
  outilne: 'secondary',
  text: 'tertiary'
};
export default function CustomButton({
  label = null,
  onClick = () => {},
  varient = '',
  variant = '',
  size = 'md',
  icon = null,
  ...props
}) {
  const resolvedVariant = variant || varient;

  const { t } = useTranslation();
  return (
    <Button
      {...props}
      size={size}
      variant={varirntMap[resolvedVariant] || resolvedVariant}
      onClick={onClick}
      icon={icon}
      text={label ? t(`${label}`) : undefined}
    />
  );
}

CustomButton.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.element,
  onClick: PropTypes.func,
  varient: PropTypes.string
};
